
class ProfileAPI {
    static buildPreview = ( a, b ) => {
        var s = a || '';
        s += b ? '-' + b : '';
        return s;
    }
    static profile = {
        categories: [
            {
                name: 'Personal Information',
                completed: true,
                data: [{
                    profilePic:{
                        name: 'profilePic',
                        label: '',
                        required: true,
                        value: '',
                        type: 'image'
                    },
                    firstName:{
                        name: 'firstName',
                        label: 'First Name',
                        required: true,
                        value: 'Bruce',
                        type: 'text'
                    },
                    lastName:{
                        name: 'lastName',
                        label: 'Last Name',
                        required: true,
                        value: 'Wayne',
                        type: 'text'
                    },
                    email:{
                        name: 'email',
                        label: 'Email Id',
                        required: true,
                        value: 'bruce@gmail.com',
                        type: 'email'
                    },
                    contact:{
                        name: 'contact',
                        label: 'Contact Number',
                        required: true,
                        value: '8844332211',
                        type: 'number'
                    },
                    state:{
                        name: 'state',
                        label: 'State',
                        required: true,
                        value: 'Karnataka',
                        type: 'text'
                    },
                    city:{
                        name: 'city',
                        label: 'City',
                        required: true,
                        value: 'Bangalore',
                        type: 'text'
                    },
                    about:{
                        name: 'about',
                        label: 'About You',
                        required: true,
                        value: 'Our job board aims to provide better are spendsemployment opportunities. Thus, we thoroughly screen every accessible to the are spendsposition before his bgg approving it. This is published by an gbg bbgbg actual individual who are spends up to 30 minutes per job, I am making sure it passes our stringent standards.',
                        otherProps: { multiline: true, rows: 10, showCharCount: true, inputProps: { minLength: 150, maxLength: 1000 } }
                    }
                }]
            },
            {
                name: 'Work Experience',
                completed: false,
                multiValue: true,
                renderPreview: (values) => this.buildPreview(values?.title?.value, values?.company?.value),
                data: [{
                    name:{
                        name: 'city',
                        label: 'City And State Of Company',
                        required: true,
                        value: 'Chennai, Tamil Nadu',
                        type: 'dropdown',
                        options: ['Chennai, Tamil Nadu', 'Bangalore, Karnataka']
                    },
                    company:{
                        name: 'company',
                        label: 'Company Name',
                        required: true,
                        value: 'ABC Technologies',
                        type: 'text'
                    },
                    title:{
                        name: 'title',
                        label: 'Job Title',
                        required: true,
                        value: 'UI/UX Designer',
                        type: 'dropdown',
                        options: ['UI/UX Designer', 'Web Developer', 'Data Analyst']
                    },
                    dateOfJoining:{
                        name: 'dateOfJoining',
                        label: 'Joined Date',
                        required: true,
                        value: '05/24/2018',
                        type: 'date'
                    },
                    workedTill:{
                        name: 'workedTill',
                        label: 'Worked Till',
                        required: true,
                        value: '02/01/2020',
                        placeholder: 'Select End Date',
                        isPresent: false,
                        type: 'date',
                        otherProps: { optionalName: 'isPresent', label: 'Present' }
                    },
                    description:{
                        name: 'description',
                        label: 'Description',
                        required: true,
                        value: 'Do you have a bulk order or a small order? Don\'t worry; I will be your ideal choice in that case as I have enough experience to deliver quality work efficiently. Also, my experience allows me to deliver all the work in just 24 hours of ordering. Speed is my first quality, so you can be free from worries about any work delay.',
                        otherProps: { multiline: true, rows: 4, showCharCount: true, inputProps: { minLength: 150, maxLength: 1000 } }
                    }
                }]
            },
            {
                name: 'Educational Details',
                completed: false,
                multiValue: true,
                renderPreview: (values) => this.buildPreview(values?.degree?.value, values?.major?.value),
                data: [{
                    city:{
                        name: 'city',
                        label: 'City And State Of College/University',
                        required: true,
                        value: 'Chennai, Tamil Nadu',
                        type: 'dropdown',
                        options: ['Chennai, Tamil Nadu', 'Bangalore, Karnataka']
                    },
                    college:{
                        name: 'college',
                        label: 'College/University Name',
                        required: true,
                        value: 'ABC College Of Engineering'
                    },
                    degree:{
                        name: 'degree',
                        label: 'Degree',
                        required: true,
                        value: 'B.Tech',
                        type: 'dropdown',
                        options: ['B.Tech', 'B.E']
                    },
                    major:{
                        name: 'major',
                        label: 'Major',
                        required: true,
                        value: 'Information Technology',
                        type: 'dropdown',
                        options: ['Information Technology', 'Computer Science']
                    },
                    cgpa:{
                        name: 'cgpa',
                        label: 'CGPA Or Grade',
                        required: true,
                        value: 'ABC College Of Engineering'
                    },
                    year:{
                        name: 'year',
                        label: 'Year Of Completion',
                        required: true,
                        value: '2018',
                        type: 'dropdown',
                        options: [1970, 1971, 1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979, 1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022]
                    }
                }]
            },
            {
                name: 'Skills',
                completed: false,
                data: [{
                    skills: {
                        name: 'skills',
                        label: '',
                        required: true,
                        value: ['Adobe Photoshop', 'Illustrator', 'Premier Pro', 'After Effects', 'Adobe XD',],
                        type: 'dropdown',
                        options: ['Adobe Photoshop', 'Illustrator', 'Premier Pro', 'After Effects', 'Adobe XD', 'Editing', 'Proof Reading', 'Book Editing', 'Article Editing', 'Rewriting & Revisions', 'Technical Editing'],
                        otherProps: { renderValue: (selected) => 'Select Your Proof Reading Categories', multiple: true, outerSelection: true }
                    }
                }]
            },
            {
                name: 'Certification',
                completed: false,
                multiValue: true,
                renderPreview: (values) => this.buildPreview(values?.course?.value),
                data: [{
                    course: {
                        name: 'course',
                        label: 'Certificate Cource Name',
                        required: true,
                        value: 'Diploma In UI/UX Design'
                    },
                    certificate:{
                        name: 'certificate',
                        label: 'Certificate/Award',
                        required: true,
                        value: 'Best Performer'
                    },
                    certificateFrom:{
                        name: 'certificateFrom',
                        label: 'Certified From',
                        required: true,
                        value: 'ABC Technologies'
                    },
                    issuedOn:{
                        name: 'issuedOn',
                        label: 'Issued On',
                        required: true,
                        value: '12/05/2018',
                        type: 'date'
                    },
                    expiresOn:{
                        name: 'expiresOn',
                        label: 'Expires On',
                        required: true,
                        value: '',
                        placeholder: 'Select Expire Date',
                        isNeverExpires: false,
                        type: 'date',
                        props: { optionalName: 'isNeverExpires', label: 'Certificate Never Expires' }
                    }
                }]
            },
            {
                name: 'Portfolios',
                completed: false,
                data: [{
                    portfolios:{
                        name: 'portfolios',
                        label: 'Portfolio/Social Links',
                        required: true,
                        options: ['LinkedIn', 'GitHub', 'Facebook' , 'Twitter' , 'Discord' , 'Reddit' , 'Quora', 'Others'],
                        value: [
                            {
                                type: 'LinkedIn',
                                value: 'https://www.linkedin/kaira'
                            },
                            {
                                type: 'GitHub',
                                value: 'https://www.github/kaira'
                            }
                        ],
                        type: 'multiInput'
                    }
                }]
            }
        ]
    }
    
    static getUser = (email) => {
        //change this api calling logic with actual API
        return {
            email: email,
            name: 'Bruce Wayne'
        }
    }
    static getSetting = () => {
        //change this api calling logic with actual API
        let data = localStorage.getItem('settings');
        if(data) {
            return JSON.parse(data);
        }
        this.profile && localStorage.setItem('settings', JSON.stringify(this.profile));
        return this.profile;
    }
    static profileCompleted = () => {
        let settings = this.getSetting();
        return parseInt((settings.categories.filter(c => c.completed).length / settings.categories.length) * 100)
    }
    static updateSetting = (i ,settings) => {
        let profile = this.getSetting();
        profile.categories[i].data = settings;
        profile.categories[i].completed = true;
        localStorage.setItem('settings', JSON.stringify(profile));
    }
}
export default ProfileAPI;